import { useEffect } from 'react';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { Context } from '../../../config/store';
import message from '../../../constant/message';
import LenderUgroService from '../../../services/lender';
import Modal from '../../Modal';

const AssignLenderUserModal = ({
	modelState,
	toggleModal,
	selectedIds,
	reloadTable,
}) => {
	const { state } = useContext(Context);
	const [users, setUsers] = useState([]);
	const [errors, setErrors] = useState({});
	const [currentUser, setCurrentUser] = useState(null);
	const assignLender = async (e) => {
		e.preventDefault();
		try {
			let response;
			response = await LenderUgroService.assignUserLead({
				type: state.userType,
				requestBody: {
					user_id: currentUser,

					cl_lead_id: selectedIds[0],
				},
			});
			if (response?.data?.status?.code === 1) {
				const successMessage = response?.data?.messages?.success;
				toast.success(
					successMessage?.form?.[0] ||
						successMessage?.others?.[0] ||
						message.SAVED_SUCCESS
				);
			}

			if (reloadTable) reloadTable();
			toggleModal();
		} catch (err) {
			// console.log(err);
			let error = err?.response?.data?.messages?.error;
			toast.error(error?.form?.[0] || error?.others?.[0]);
			setErrors(error);
		}
	};
	const getAssignUsers = async () => {
		let response;
		response = await LenderUgroService.getLenderUsers({
			type: state.userType,
			leadId: selectedIds[0],
		});
		if (response?.data?.status?.code === 1) {
			setUsers(response?.data?.data);
		}
	};
	const setSelectedUser = (e) => {
		setCurrentUser(e.target.value);
	};
	useEffect(() => {
		getAssignUsers();
	}, []);
	return (
		<Modal state={modelState} closeModal={toggleModal}>
			{' '}
			<form onSubmit={assignLender}>
				<h6 className='mb-2 mt-2'>
					<b>
						<small>Assign to</small>
					</b>
				</h6>
				<div className='form-group mb-0'>
					<div className='custom_control d-flex flex-wrap'>
						<select name='entity-type' onChange={setSelectedUser}>
							<option value={''}>Select</option>
							{(users || []).map(({ full_name, user_id}) => (
								<option
									className='custom_radio_control mr-4'
									value={user_id}
									key={user_id}
								>
									{full_name }
								</option>
							))}
						</select>
					</div>
					{errors && (
						<p className='mt-2 mb-0 text-danger'>
							{errors?.fields?.lender_id?.[0]}
						</p>
					)}
				</div>
				<div className='d-flex'>
					<button type='submit' className='btn btn-custom'>
						OK
					</button>
					<button
						type='button'
						className='btn btn-outline-custom ml-2'
						data-dismiss='modal'
						onClick={toggleModal}
					>
						Cancel
					</button>
				</div>
			</form>
		</Modal>
	);
};

export default AssignLenderUserModal;
